// extracted by mini-css-extract-plugin
module.exports = {"header":"header-module--header--2Q3RK","siteTitle":"header-module--siteTitle--OLBqf","motto":"header-module--motto--1qfLn","siteTitleLink":"header-module--siteTitleLink--3RrVN"};